// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"680c46e98a722b11b83b","293":"f81a165937bc4902c265","518":"4deb642c0194733272f3","779":"0a6f981be49fff02520f"}[chunkId] + ".js";
};